import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { OfferSession } from 'app/shared/models/class/session/session';
import { SessionService } from 'app/shared/services/session/session.service';

@Component({
  selector: 'app-session-form',
  templateUrl: './session-form.component.html',
  styleUrls: ['./session-form.component.scss']
})
export class SessionFormComponent implements OnInit {
  @Input() sessionSelected: OfferSession;
  @Input() actionFormSession: string;
  @Input() offerKey: number;

  @Output() addSession = new EventEmitter<boolean>();

  sessionForm: UntypedFormGroup;
  today = new Date();

  constructor(
    private formBuilder: UntypedFormBuilder,
    private sessionService: SessionService,
    private route: ActivatedRoute,
  ) {
  }

  ngOnInit(): void {
    this.initComponent();
    this.initForm();
  }

  onSubmit(): void {
    const startDate = this.setDate(this.f.startDate.value, this.f.startHour.value);
    const endDate = this.setDate(this.f.endDate.value, this.f.endHour.value);
    const session = new OfferSession(+this.offerKey, this.f.label.value, startDate, endDate, this.f.quantity.value);

    switch (this.actionFormSession) {
      case 'add':
        this.sessionService.addSessionToOffer(session).subscribe({
          next: () => { this.addSession.emit(false); }
        });
        break;
      case 'edit':
        session.sessionKey = +this.sessionSelected.sessionKey;
        this.sessionService.updateSessionToOffer(session).subscribe({
          next: () => { this.addSession.emit(false); }
        });
        break;

      default:
        break;
    }
  }

  private initComponent(): void {
    this.actionFormSession = this.actionFormSession ? this.actionFormSession : 'add';
  }

  get f() {
    return this.sessionForm.controls;
  }

  private setDate(date: string, time: string): Date {
    const dateConvert = new Date(date);
    const timeSplit = time.split(':');
    dateConvert.setHours(+timeSplit[0]);
    dateConvert.setMinutes(+timeSplit[1]);

    return dateConvert;
  }

  private initForm(): void {
    const startDate = this.sessionSelected?.sessionStartDate.toString();
    const startHour = startDate?.split('T')[1].split(':').splice(0, 2).join(':');
    const endDate = this.sessionSelected?.sessionEndDate.toString();
    const endHour = endDate?.split('T')[1].split(':').splice(0, 2).join(':');

    this.sessionForm = this.formBuilder.group({
      label: [this.actionFormSession === 'edit' ? this.sessionSelected.dateLib : ''],
      startDate: [this.actionFormSession === 'edit' ? startDate : ''],
      startHour: [this.actionFormSession === 'edit' ? startHour : '00:00'],
      endDate: [this.actionFormSession === 'edit' ? endDate : ''],
      endHour: [this.actionFormSession === 'edit' ? endHour : '23:59'],
      quantity: [this.actionFormSession === 'edit' ? this.sessionSelected.quantity : '']
    });
  }

}
